import { Injectable } from '@angular/core';
import { PanModalComponent } from './pan-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  private modalStack: PanModalComponent[] = [];

  public addModal(modal: PanModalComponent) {
    this.modalStack.push(modal);
  }

  public async removeModal() {
    const modal = this.modalStack.pop();
    if (!modal) return;

    const dismissCheck = modal.canDismiss();
    if (dismissCheck) {
      const shouldDismiss = await dismissCheck();
      if (!shouldDismiss) {
        this.addModal(modal);
        return;
      }
    }

    modal.hide();
  }
}
